import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import LegalDocumentForm from './LegalDocumentForm/LegalDocumentForm'

import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { Breadcrumb } from 'react-breadcrumbs'

import { apiClient } from '../../../Module/API/Client'
import {
  incUIBlockCounter,
  decBlockCounter,
} from '../../../Reducers/UIBlock/actions'
import { createLegalDocument } from '../../../Reducers/LegalDocument/actions'
import { getCountries } from '../../../Reducers/Countries/actions'
import { LEGAL_DOCUMENT_FORM_MODES } from './const'
import { showReduxModal } from '../../../Reducers/UI/actions'
import { ROLE_SPY } from '../../../shared/constants'

const styles = {
  wrapper: { padding: '0 3rem' },
}

const BreadcrumbsCreateDocument = ({ match }) => {
  const currentPath = match.url

  return (
    <div>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Legal Documents',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.legalDocumentation
          }`,
        }}
      />
      <Breadcrumb data={{ title: 'Create', pathname: currentPath }} />
    </div>
  )
}

const LegalDocumentationCreate = ({
  classes,
  countries,
  getCountries,
  match,
  history,
  createLegalDocument,
  showReduxModal,
}) => {
  useEffect(() => getCountries(), [])

  const [loading, setLoading] = useState(false)

  const navigateBack = () =>
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.legalDocumentation
      }`,
    )

  const showConfirmation = fields =>
    showReduxModal({
      title: 'Confirmation needed',
      onConfirm: () => {
        handleSubmit(fields)
        return // This is made to hide modal window without waiting for response to end.
      },
      children: `You are about to upload a new document. 
        All ${
          fields.userRole === ROLE_SPY ? 'Spies' : 'Brand Ambassadors'
        } in the specified country will have to accept the new list of legal documents.`,
    })

  const handleSubmit = async fields => {
    setLoading(true)
    try {
      await createLegalDocument(fields)
      navigateBack()
    } catch (e) {
      console.error(e)
      setLoading(false)
    }
  }

  return (
    <div className={classes.wrapper}>
      <BreadcrumbsCreateDocument match={match} />
      <LegalDocumentForm
        countries={countries}
        mode={LEGAL_DOCUMENT_FORM_MODES.CREATE}
        handleSubmit={showConfirmation}
        handleCancel={navigateBack}
        buttonsDisabled={loading}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
})

const mapDispatchToProps = dispatch => ({
  getCountries: () => dispatch(getCountries()),
  createLegalDocument: async ({ countryId, name, file, userRole }) => {
    dispatch(incUIBlockCounter())
    const url = await apiClient.uploadLegalDocument(file, countryId)
    dispatch(decBlockCounter())

    return await dispatch(
      createLegalDocument({ countryId, name, url, userRole }),
    )
  },
  showReduxModal: (...args) => dispatch(showReduxModal(...args)),
})

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(LegalDocumentationCreate)),
)



// WEBPACK FOOTER //
// ./src/Containers/Settings/LegalDocumentation/LegalDocumentationCreate.jsx